module.exports = __webpack_public_path__ + "media/images/icon-reset@3x-0f693932fbccaf4f5c1bd4455e5d0911.png";